/** Stable ordering of product-with-media definition kinds. Unknown kinds follow, alphabetically. */
export const KIND_ORDER = ["canvas", "greeting-card", "invitation", "menu", "map"];

/** The catalogue's order: by kind, then the API's own order within a kind (newest first). */
export function sortDefinitions<T extends { kind?: string }>(definitions: T[]): T[] {
  const rank = (kind: string) => {
    const i = KIND_ORDER.indexOf(kind);
    return i === -1 ? KIND_ORDER.length : i;
  };
  return definitions
    .map((def, index) => ({ def, index }))
    .sort((a, b) => {
      const ka = a.def.kind ?? "other";
      const kb = b.def.kind ?? "other";
      const byRank = rank(ka) - rank(kb);
      if (byRank !== 0) return byRank;
      const byKind = ka.localeCompare(kb);
      if (byKind !== 0) return byKind;
      return a.index - b.index;
    })
    .map(({ def }) => def);
}
